import * as React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/pro-regular-svg-icons/faChevronCircleLeft";
import { Button, ButtonProps } from "@mui/material";
import { useTranslation } from 'react-i18next';

interface IProps {
    text?: string;
}

type Props = IProps & Omit<ButtonProps, "color" | "startIcon">;

const ButtonBack: React.FC<Props> = ({ text, children, ...rest }) => {
    const { t } = useTranslation();

    if (text == null) text = t("Common.Buttons.BackText");

    return (
        <Button
            color="inherit"
            startIcon={<FontAwesomeIcon icon={faChevronCircleLeft} />}
            {...rest}
        >
            {text || children}
        </Button>
    );
};

export default ButtonBack;